import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as OFMSUI from "react-bootstrap";
import { Formik, Field, useFormik, FormikProvider, } from "formik";
import NavigationServicesHeader from "../Header/NavigationServicesHeader";
import { Form, FormGroup, FormLabel, Row, Col, Button, Table, } from "react-bootstrap";
import * as Yup from "yup";
import HousingService from "../Services/HousingService";
import { store } from "../App";
import ShowAlert from "./alert";
import { BiUser } from "react-icons/bi";
import { useHistory } from "react-router";
const RoleServiceMapping = () => {
  const history = useHistory();
  const [roleList, setRoleList] = useState();
  const [data, setdata] = useState();
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.getRolesList().then((res) => {
      if (res.data[0].Parent_ID_List) {
        let options = res.data[0].Parent_ID_List.map((item, i) => {
          return ( <option key={i} value={item.role_id}> {item.role_name} </option> );
        });
        setRoleList(options);
      }
      store.dispatch({ type: "HIDE_SPINNER" });
    });
  }, []);

  function handleGoBack() { 
    history.goBack();
  }

  const formik = useFormik({
    initialValues: {
      role_id: "",
      service_ids: [],
    },
    onSubmit: (values) => {
        let filtereddata = [];
        if (formik.values.service_ids.filter((rowdata)=> rowdata.checkbox===true) !== undefined && formik.values.service_ids.filter((rowdata)=> rowdata.checkbox===true) !== null) {
            filtereddata = formik.values.service_ids.filter((rowdata)=> rowdata.checkbox===true).map((item) => {
                let service_ids = "";
                if ( item !== undefined && item.service_id !== "") {
                service_ids = {
                    service_id: item.service_id,
                };
                }
                return service_ids;
            });
        }
        
        let finalList = filtereddata.filter(
            (item) => item !== "" && item !== undefined && item !== null
        );
        let params = {
            role_id: values.role_id,
            service_ids: finalList,
        };
        store.dispatch({ type: "SHOW_SPINNER" });
        HousingService.RoleServiceMapping(params).then((res) => {
            if (res.data[0].responseMsg === "Data Inserted Successfully") {
            ShowAlert("Services Mapped Successfully", "success").then(function ( isConfirm ) {
                 if (isConfirm.value) { history.go(0); } 
            });
            } else {
                ShowAlert(res.data[0].responseMsg, "error");
            }
            store.dispatch({ type: "HIDE_SPINNER" });
        });
        },
  });

  function getRoleBasedServices(){
    let role_id = formik?.values?.role_id;
    if ( role_id === "" || role_id === "undefined" || typeof role_id === "undefined" || role_id === "Select" ) {
      setdata();
      ShowAlert("Please Select Role Name", "error");
      return false;
    }
    store.dispatch({ type: "SHOW_SPINNER" });
    HousingService.getServicesListWithRoleID(formik.values.role_id).then((res) => {
        setdata(res.data[0].Parent_ID_List);
        let array=[];
        for(let jj=0;jj<res.data[0].Parent_ID_List.length;jj++) {
            array.push({service_id:res.data[0].Parent_ID_List[jj].service_id,checkbox:res.data[0].Parent_ID_List[jj].checked==="checked"?true:false,service_name:res.data[0].Parent_ID_List[jj].service_name});
            formik.setFieldValue(`service_ids[${jj}].checkbox`,res.data[0].Parent_ID_List[jj].checked==="checked"?true:false);
        }
        formik.setFieldValue('service_ids',array);
        store.dispatch({ type: "HIDE_SPINNER" });
    });
  }

  return (
    <>
      <NavigationServicesHeader />
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>
          <OFMSUI.Container>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="page-titlespacing" > 
              <div className="inner-herbpage-service-title1"> <h1 style={{ marginLeft: "-15px" }}> Role Service Mapping</h1> </div> 
              </OFMSUI.Col>

              <OFMSUI.Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="page-titlespacing" >
                <button type="button" className="btn btn-outline-primary" style={{ textAlign: "right", float: "right", marginTop: "17px", }} onClick={handleGoBack} > Back </button>
              </OFMSUI.Col>
            </OFMSUI.Row>
          </OFMSUI.Container>

          <OFMSUI.Container className="outer-page-content-container ">
            <div>
              <OFMSUI.Row className="p-3" style={{ textAlign: "left" }}>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                  <FormGroup as={Col}>
                    <FormLabel>
                      <h6 style={{ color: "var(--dark-gray)", fontWeight: "Bold", }} > Role Name </h6>
                    </FormLabel>
                    <span className="mandatory" style={{ color: "red" }}> * </span>
                    <Field name="role_id" component="select" className={ formik.touched.role_id && formik.errors.role_id ? "form-control is-invalid" : "form-control" } >
                      <option>Select</option>
                      {roleList}
                    </Field>
                  </FormGroup>
                </OFMSUI.Col>
               
                <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="" > 
                    <div className="d-grid  mt-9  "> 
                        <button type="button" className="btn btn-success  mb-2 mx-1 " style={{marginTop:'40px'}} onClick={() => { getRoleBasedServices(); }} > Go </button>
                    </div> 
                </OFMSUI.Col>
              </OFMSUI.Row>
              
                <OFMSUI.Row>
                <OFMSUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} >
                    <OFMSUI.Table  className="table table-bordered table_check1" id="my-table">
                    {data === undefined || data?.length === 0 ? (
                    <tr> </tr> ) : (
                    <tbody>
                        <tr>
                        <td style={{textAlign:'left'}}>
                            {formik?.values?.service_ids?.map((detail, i) => (
                            i % 2 === 0 ? (
                                <div key={i}>
                                <Field type="checkbox" name={`service_ids[${i}].checkbox`} className="checkbox" onClick={(e) => { setChecked(e.target.checked) }} style={{ width: "25px", height: "20px" }} />
                                {detail.service_name}
                                </div>
                            ) : null
                            ))}
                        </td>
                        <td style={{textAlign:'left'}}>
                            {formik?.values?.service_ids?.map((detail, i) => (
                            i % 2 !== 0 ? (
                                <div key={i}>
                                <Field type="checkbox" name={`service_ids[${i}].checkbox`} className="checkbox" onClick={(e) => { setChecked(e.target.checked) }} style={{ width: "25px", height: "20px" }} />
                                {detail.service_name}
                                </div>
                            ) : null
                            ))}
                        </td>
                        </tr>
                    </tbody>
                    )}
                    </OFMSUI.Table>
                </OFMSUI.Col>
                </OFMSUI.Row>
  
                <OFMSUI.Row>
                <OFMSUI.Col xs={12} sm={12} md={1} lg={1} xl={1} xxl={1}>
                    {data === undefined || data?.length === 0 ? (
                    <tr> </tr> ) : (
                        <button type="submit" className="btn btn-primary btn-sm  mb-2 float-right mx-1" > Submit </button>
                    )}
                </OFMSUI.Col>
                <OFMSUI.Col xs={12} sm={12} md={11} lg={11} xl={11} xxl={11}> </OFMSUI.Col>
                </OFMSUI.Row>
            </div>
          </OFMSUI.Container>
        </Form>
      </FormikProvider>
    </>
  );
};
export default RoleServiceMapping;
